import React from 'react'
import { Link, useLocation, useNavigate } from 'react-router-dom';
import Modal from 'react-bootstrap/Modal';
import { useState, useEffect, useRef } from 'react';

import Podcastblock from '../component/Podcastblock';

import { FaBackward } from "react-icons/fa";
import { FaPauseCircle } from "react-icons/fa";
import { FaPlayCircle } from "react-icons/fa";
import { FaForward } from "react-icons/fa";
import { FaCalendarDay } from "react-icons/fa";
import { FaPlay } from "react-icons/fa";
import { FaEllipsisV } from "react-icons/fa";
import { FaShareAlt } from "react-icons/fa";

export default function Home() {

    const navigate = useNavigate();
    const [modalShow, setModalShow] = useState(false);
    const { hash } = useLocation();

    // State for S3 fetched data
    const [podcastData, setPodcastData] = useState(null);
    const [podcastKey, setPodcastKey] = useState(null);
    const [isLoading, setIsLoading] = useState(true);

    const [isPlaying, setIsPlaying] = useState(false);
    const [currentTrack, setCurrentTrack] = useState('1810411879024095');
    const [audioProgress, setAudioProgress] = useState(0);

    const [musicTotalLength, setMusicTotalLength] = useState('04 : 38');
    const [musicCurrentTime, setMusicCurrentTime] = useState('00 : 00');

    const currentAudio = useRef(null);

    // Fetch JSON files from S3 when component mounts
    useEffect(() => {
        const fetchPodcastData = async () => {
            try {
                const [dataRes, keyRes] = await Promise.all([
                    fetch('https://issuewireassets.s3.us-west-2.amazonaws.com/podcast/getPodcast.json'),
                    fetch('https://issuewireassets.s3.us-west-2.amazonaws.com/podcast/getPodcastKey.json')
                ]);

                if (!dataRes.ok || !keyRes.ok) {
                    throw new Error('Failed to fetch podcast files from S3');
                }

                const dataJson = await dataRes.json();
                const keyJson = await keyRes.json();

                setPodcastData(dataJson);
                setPodcastKey(keyJson);
            } catch (error) {
                console.error("Error fetching podcast data from S3:", error);
            } finally {
                setIsLoading(false);
            }
        };

        fetchPodcastData();
    }, []);

    // Handle track changes and reliable autoplay once data is available
    useEffect(() => {
        if (!podcastData) return;

        if (currentAudio.current) {
            currentAudio.current.pause();
            currentAudio.current.currentTime = 0;
            setMusicCurrentTime('00:00');
            setAudioProgress(0);
            
            if (podcastData[0] && podcastData[0][currentTrack]) {
                setMusicTotalLength(podcastData[0][currentTrack].duration);
                currentAudio.current.src = podcastData[0][currentTrack].enclosure.url;
                
                const playPromise = currentAudio.current.play();
                if (playPromise !== undefined) {
                    playPromise.then(() => {
                        setIsPlaying(true);
                    }).catch(error => {
                        console.error("Autoplay was prevented or interrupted:", error);
                        setIsPlaying(false);
                    });
                }
            }
        }
    }, [currentTrack, podcastData]);

    useEffect(() => {
        if (hash && podcastData) {
            setModalShow(true);
            const selectMusic = hash.replace('#isw', '');
            setCurrentTrack(selectMusic);
        }
    }, [hash, podcastData]);

    const handlePlayPause = () => {
        if (isPlaying) {
            currentAudio.current.pause();
            setIsPlaying(false);
        } else {
            const playPromise = currentAudio.current.play();
            if (playPromise !== undefined) {
                playPromise.then(() => {
                    setIsPlaying(true);
                }).catch((error) => {
                    console.error(error);
                });
            }
        }
    };

    const handleNextTrack = () => {
        if (!podcastKey) return;
        const currentTrackIndex = podcastKey.indexOf(currentTrack);
        let nextTrackIndex = currentTrackIndex + 1 >= podcastKey.length ? 0 : currentTrackIndex + 1;

        const nextKey = podcastKey[nextTrackIndex];
        setCurrentTrack(nextKey);
        navigate('/#isw' + nextKey);
    };

    const handlePrevTrack = () => {
        if (!podcastKey) return;
        const currentTrackIndex = podcastKey.indexOf(currentTrack);
        let prevTrackIndex = currentTrackIndex - 1 < 0 ? podcastKey.length - 1 : currentTrackIndex - 1;

        const prevKey = podcastKey[prevTrackIndex];
        setCurrentTrack(prevKey);
        navigate('/#isw' + prevKey);
    };

    const handleTrackChange = (index) => {
        setCurrentTrack(index);
    };

    const handleClose = () => {
        setModalShow(false); 
        navigate('#');
        if (currentAudio.current) {
            currentAudio.current.pause();
        }
        setIsPlaying(false);
    }

    const handleMusicProgressBar = (e) => {
        setAudioProgress(e.target.value);
        if (currentAudio.current && currentAudio.current.duration) {
            currentAudio.current.currentTime = e.target.value * currentAudio.current.duration / 100;
        }
    }

    let avatarClass = ['objectFitCover', 'objectFitContain', 'none']
    const [avatarClassIndex, setAvatarClassIndex] = useState(0)
    const handleAvatar = () => {
        setAvatarClassIndex((prev) => (prev >= avatarClass.length - 1 ? 0 : prev + 1));
    }

    const handleAudioUpdate = () => {
        if (!currentAudio.current) return;
        let minutes = Math.floor(currentAudio.current.duration / 60);
        let seconds = Math.floor(currentAudio.current.duration % 60);
        setMusicTotalLength(`${minutes < 10 ? `0${minutes}` : minutes} : ${seconds < 10 ? `0${seconds}` : seconds}`);

        let currentMin = Math.floor(currentAudio.current.currentTime / 60);
        let currentSec = Math.floor(currentAudio.current.currentTime % 60);
        setMusicCurrentTime(`${currentMin < 10 ? `0${currentMin}` : currentMin} : ${currentSec < 10 ? `0${currentSec}` : currentSec}`);

        const progress = parseInt((currentAudio.current.currentTime / currentAudio.current.duration) * 100);
        setAudioProgress(isNaN(progress) ? 0 : progress)
    }

    if (isLoading || !podcastData) {
        return <div className="text-center py-5" style={{ color: '#fff', background: '#000', minHeight: '100vh', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>Loading Podcasts...</div>;
    }

    return (
        <>
            <main className="herobanner">
                <img src="https://elpemailimg.s3.us-west-2.amazonaws.com/issuewire/podcust/images/round-circle.png" alt="title" className="podcast-round-shape bannershape" />
                <div className="fixed-bg banner-bg2 overlay"></div>
                <div className="container">
                    <div className="row">
                        <div className="col-sm-10 col-md-8 col-lg-6">
                            <div className="hero_wrapper">
                                <h1>Convert Press Releases into an enthralling audio experience with our professional Podcast service</h1>
                                <p>Innovative strategies to keep your audience engaged in your business.</p>
                                <br />
                                <div><Link to="https://www.issuewire.com/signup/pricingdetails" className="btn primarybtn btn-lg btn-block" type="button"><span>Submit PR for Podcast</span></Link></div>
                            </div>
                        </div>
                    </div>
                </div>
            </main>

            <section className="quick_sec">
                <div className="container">
                    <div className="quick_wrapper">
                        <div className="row justify-content-center">
                            <div className="col-sm-6 col-md-6 col-lg-3">
                                <div className="quick_item">
                                   <Link to="https://open.spotify.com/show/0F1QGMse3zapOIFkbqi2Yh?si=5d4690009cbd4395" target="_blank" ><div className="quick_img"><img src="https://issuewireassets.s3.us-west-2.amazonaws.com/podcast/spotify.jpg" alt="Spotify Podcast" loading="lazy" title="Spotify Podcast" /></div></Link> 
                                   <Link to="https://open.spotify.com/show/0F1QGMse3zapOIFkbqi2Yh?si=5d4690009cbd4395" target="_blank" style={{ textDecoration: 'none' }}><div className="quick_text">Spotify Podcast</div></Link>
                                </div>
                            </div>
                            <div className="col-sm-6 col-md-6 col-lg-3">
                                <div className="quick_item">
                                    <Link to="https://music.amazon.in/podcasts/5748bb0f-7936-4b37-addd-d65fda332434/issuewire-podcast-issuewire" target="_blank">
                                    <div className="quick_img"><img src="https://issuewireassets.s3.us-west-2.amazonaws.com/podcast/amazon-music.jpg" alt="Amazon Music" loading="lazy" title="Amazon Music" /></div></Link>
                                    <Link to="https://music.amazon.in/podcasts/5748bb0f-7936-4b37-addd-d65fda332434/issuewire-podcast-issuewire" target="_blank" style={{ textDecoration: 'none' }}><div className="quick_text">Amazon Music</div></Link>
                                </div>
                            </div>
                            <div className="col-sm-6 col-md-6 col-lg-3">
                                <div className="quick_item">
                                    <div className="quick_img"><img src="https://elpemailimg.s3.us-west-2.amazonaws.com/issuewire/podcust/images/addfree.png" alt="" loading="lazy" title="" /></div>
                                    <div className="quick_text">Ad - free Podcasts</div>
                                </div>
                            </div>
                            <div className="col-sm-6 col-md-6 col-lg-3">
                                <div className="quick_item">
                                    <div className="quick_img"><img src="https://elpemailimg.s3.us-west-2.amazonaws.com/issuewire/podcust/images/addplaylist.png" alt="" loading="lazy" title="" /></div>
                                    <div className="quick_text">More Traffic Generation</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section className="trending_sec">
                <div className="container">
                    <div className="row">
                        <div className="col-sm-12">
                            <div className="section_title bg_black" data-title="Latest Podcast">
                                <h2 className="section_tText">Latest Podcast</h2>
                                <p>We create an innovative journey so that your <b>press release podcasts</b> rank higher and gain more listeners at the same time. Be it a business announcement or any relevant event, we cover everything with skills and experience.</p>
                                <p style={{ height: '40px' }}></p>
                            </div>
                        </div>

                        {
                            Object.keys(podcastData[0]).map((gridvalue) => {
                                const item = podcastData[0][gridvalue];
                                return (
                                    <div className="col-sm-12" key={gridvalue} onClick={() => handleTrackChange(item.guid)}>
                                        <div className="trending_big">
                                            <div className="trnding_wrapper">
                                                <div className="playbtn"><Link to={"#isw" + item.guid} style={{ textDecoration: 'none' }} ><FaPlay /></Link></div>
                                                <Link to={"#isw" + item.guid} className="trending_big_img" >
                                                    <img src={item.image.href} loading="lazy" alt="" className="img-fluid" title="" />
                                                </Link>
                                            </div>
                                            <div className="trending_big_content" style={{ padding: '10px' }}>
                                                <p className="trending_date" style={{ display: 'inline', textAlign: 'left' }}><FaCalendarDay /> {item.pubDate} </p>
                                                <Link to={"#isw" + item.guid} title="" className="b_trendingtext" style={{ display: 'block' }}>{item.title}</Link>
                                                <p className="trending_para">{item.description}</p>
                                            </div>
                                        </div>
                                    </div>
                                )
                            })
                        }
                    </div>
                </div>
            </section>

            <section className="categories_sec">
                <div className="container">
                    <div className="row">
                        <div className="col-sm-12">
                            <div className="section_title bg_black" data-title="Categories">
                                <h2 className="section_tText">Our Categories</h2>
                                <p>You can now choose the services and see your podcast enlisted under the exact category. We have introduced different PR sections such as – Business and Technology, News and Politics, Arts and Entertainment, Comedy, Music, Books, Mythology and so on.</p>
                                <p style={{ height: '40px' }}></p>
                            </div>
                        </div>
                        <div className="col-sm-12">
                            <div className="categories_listing">
                                <Link to="/" className="categories_wrapper">
                                    <div className="categories_title">Banking</div>
                                    <div className="categories_item">
                                        <div className="categories_img"><img src="https://s3-us-west-2.amazonaws.com/issuewireassets/primg/128389/thumb_abel-11638671171.png" loading="lazy" alt="" /></div>
                                    </div>
                                </Link>
                                <Link to="/" className="categories_wrapper">
                                    <div className="categories_title">Books</div>
                                    <div className="categories_item">
                                        <div className="categories_img"><img src="https://s3-us-west-2.amazonaws.com/issuewireassets/primg/128336/thumb_michelle-mcgowen-recognized-by-bestagentsus-as-a-2023-top-agent16.jpg" loading="lazy" alt="" /></div>
                                    </div>
                                </Link>
                                <Link to="/" className="categories_wrapper">
                                    <div className="categories_title">Business</div>
                                    <div className="categories_item">
                                        <div className="categories_img"><img src="https://s3-us-west-2.amazonaws.com/issuewireassets/primg/128413/thumb_al-azhar-quran-teaching-launches-innovative-online-arabic-learning-platform68.jpg" loading="lazy" alt="" /></div>
                                    </div>
                                </Link>
                                <Link to="/" className="categories_wrapper">
                                    <div className="categories_title">Entertainment</div>
                                    <div className="categories_item">
                                        <div className="categories_img"><img src="https://s3-us-west-2.amazonaws.com/issuewireassets/primg/128370/thumb_best-online-furniture-store-in-india.png" loading="lazy" alt="" /></div>
                                    </div>
                                </Link>
                                <Link to="/" className="categories_wrapper">
                                    <div className="categories_title">Events</div>
                                    <div className="categories_item">
                                        <div className="categories_img"><img src="https://s3-us-west-2.amazonaws.com/issuewireassets/primg/128360/thumb_awakening-pure-organic-medium-roast-coffee-single-origin-ethically-sourced-from-peru490676831.jpg" loading="lazy" alt="" /></div>
                                    </div>
                                </Link>
                                <Link to="/" className="categories_wrapper">
                                    <div className="categories_title">Legal</div>
                                    <div className="categories_item">
                                        <div className="categories_img"><img src="https://s3-us-west-2.amazonaws.com/issuewireassets/primg/128430/thumb_matthew-l-anderson-md-phd-facog-a-gynecologic-oncologist-with-tampa-general-hospital78.png" loading="lazy" alt="" /></div>
                                    </div>
                                </Link>
                                <Link to="/" className="categories_wrapper">
                                    <div className="categories_title">Lifestyle</div>
                                    <div className="categories_item">
                                        <div className="categories_img"><img src="https://s3-us-west-2.amazonaws.com/issuewireassets/primg/128434/thumb_unnamed-2024-01-18t103635-0841366352660.png" loading="lazy" alt="" /></div>
                                    </div>
                                </Link>
                                <Link to="/" className="categories_wrapper">
                                    <div className="categories_title">Non-Profit</div>
                                    <div className="categories_item">
                                        <div className="categories_img"><img src="https://s3-us-west-2.amazonaws.com/issuewireassets/primg/128457/thumb_jenna-matheny-recognized-by-bestagentsus-as-a-2023-top-agent33.jpg" loading="lazy" alt="" /></div>
                                    </div>
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section className="trending_sec">
                <div className="container">
                    <div className="row">
                        <div className="col-sm-12">
                            <div className="section_title bg_black" data-title="About Podcast">
                                <h2 className="section_tText">About Podcast</h2>
                                <p>Before setting up this latest audio PR website, Issuewire has been a part of the PR writing and distribution network where it has won some incredible recognitions.</p>
                                <p style={{ height: '40px' }}></p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Modal Player */}
            <Modal
                size="md"
                aria-labelledby="contained-modal-title-vcenter"
                centered show={modalShow}
                onHide={handleClose}
            >
                <Modal.Header closeButton closeVariant="white">
                </Modal.Header>
                <Modal.Body>
                    <div className="container">
                        {podcastData[0][currentTrack] && (
                            <>
                                <audio 
                                    src={podcastData[0][currentTrack].enclosure.url} 
                                    ref={currentAudio} 
                                    autoPlay
                                    onEnded={handleNextTrack} 
                                    onTimeUpdate={handleAudioUpdate} 
                                ></audio>
                                <div className="music-Container">
                                    <p className='musicPlayer'>Music Player</p>
                                    <p className='music-Head-Name'>{podcastData[0][currentTrack].title}</p>
                                    <img src={podcastData[0][currentTrack].image.href} className={avatarClass[avatarClassIndex]} onClick={handleAvatar} alt="song Avatar" id='songAvatar' />
                                    <div className="musicTimerDiv">
                                        <p className='musicCurrentTime'>{musicCurrentTime}</p>
                                        <p className='musicTotalLenght'>{musicTotalLength}</p>
                                    </div>
                                    <input type="range" name="musicProgressBar" className='musicProgressBar' value={audioProgress} onChange={handleMusicProgressBar} />
                                    <div className="musicControlers row" style={{ width: '100%' }}>
                                        <div className="col-2"></div>
                                        <div className="col-8">
                                            <FaBackward className='musicControler' onClick={handlePrevTrack} />
                                            {isPlaying ? <FaPauseCircle className='musicControler' onClick={handlePlayPause} /> : <FaPlayCircle className='musicControler' onClick={handlePlayPause} />}
                                            <FaForward className='musicControler' onClick={handleNextTrack} /> 
                                        </div>
                                        <div className="col-2"></div>
                                    </div>
                                </div>
                            </>
                        )}
                    </div>
                    <br />
                </Modal.Body>
            </Modal>
        </>
    )
}